import { useTranslation } from "react-i18next";
import "./HomeMobile.css";

import logoStudio from "../ArtWork/LancherixStudioLogoWhiteWhite.png";
import cardLogo from "../ArtWork/Card/LancherixCardLogoBlueBlackAffinity.png";

import iconFood from "../ArtWork/Card/Food.png";
import iconTransport from "../ArtWork/Card/Transport.png";
import iconSchool from "../ArtWork/Card/School.png";
import iconEntertainment from "../ArtWork/Card/Entertainment.png";
import iconShopping from "../ArtWork/Card/Shopping.png";
import iconSavings from "../ArtWork/Card/Savings.png";
import iconOther from "../ArtWork/Card/Other.png";

const cardCategories = [
  { key: "food", src: iconFood },
  { key: "transport", src: iconTransport },
  { key: "school", src: iconSchool },
  { key: "entertainment", src: iconEntertainment },
  { key: "shopping", src: iconShopping },
  { key: "savings", src: iconSavings },
  { key: "other", src: iconOther },
];

function HomeMobile() {
  const { t } = useTranslation();

  return (
    <div className="HomeMobile">
      {/* CARD */}
      <section className="HomeMobile-Card">
        <img
          src={cardLogo}
          alt={t("card.hero.logoAlt")}
          className="HomeMobile-CardLogo"
        />

        <h2>{t("card.hero.headline")}</h2>

        <div className="HomeMobile-CardIcons">
          {cardCategories.map((category) => (
            <img
              key={category.key}
              className="HomeMobile-CardIcon"
              src={category.src}
              alt={t(`card.hero.categories.${category.key}`)}
            />
          ))}
        </div>

        <div className="HomeMobile-CardButtons">
          <button
            onClick={() => {
              window.location.href = "https://www.lancherix.com/card";
            }}
          >
            {t("card.studio.cta")}
          </button>

          <button
            onClick={() =>
              window.open(
                "https://card.lancherix.com",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            {t("nav.login")}
          </button>
        </div>
      </section>
      {/* STUDIO HERO */}
      <section className="HomeMobile-Hero">
        <img src={logoStudio} alt={t("studio.hero.logoAlt")} />

        <h1>{t("studio.hero.title")}</h1>

        <p>{t("studio.hero.description")}</p>

        <div className="HomeMobile-HeroButtons">
          <button
            onClick={() => {
              window.location.href = "https://www.lancherix.com/studio";
            }}
          >
            {t("card.studio.cta")}
          </button>

          <button
            onClick={() =>
              window.open(
                "https://studio.lancherix.com/login",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            {t("nav.login")}
          </button>
        </div>
      </section>
    </div>
  );
}

export default HomeMobile;